import { useMemo, useState } from 'react';
import { ItemLink } from '../item';
import DeliverySelect from '../delivery-select';

const TypeLabel = ({ t }) => {
	const _t = t.toUpperCase();
	const firstChar = _t.charAt(0);
	const rest = _t.slice(1);
	return <><strong>{`[${firstChar}]`}</strong>{rest}</>;
}

const ListItem = ({ item }) => {
	return (
		<li
			className={`${item?.isAgent ? 'is-agent' : ''} ${item?.isCatalyst ? 'is-catalyst' : ''}`}
		>
			{
				!item ? '---' :
					<label htmlFor={`item-${item.id}`}>
						<input type="checkbox" id={`item-${item.id}`} />
							{item?._count ? ` ${item._count}x` : ''}{' '}
							<ItemLink item={item} />{' '}
							{item?.type ?
								<span className={`chip ${item.element.toLowerCase()}`}>
									<TypeLabel t={item.type} />
								</span> :
								''
							}
							{item?.isCatalyst && <span className="chip quality catalyst">[CATALYST]</span>}
							{item?.isAgent && <span className="chip quality agent">[AGENT]</span>}
					</label>
			}
		</li>
	);
}

const ListView = ({ items, reduce = true, className = '', withDeliverySelect }) => {
	const [delivery, setDelivery] = useState(null);
	const shoppingList = useMemo(() => {
		if (reduce) {
			// Count and filter out duplicates.
			return items.reduce((acc, item) => {
				if (!item) return acc;
				const existingItem = acc.find((i) => i.id === item.id);
				if (existingItem) {
					existingItem._count++;
				} else {
					acc.push({ ...item, _count: 1 });
				}
				return acc;
			}, []);
		}
		return items;
	}, [items, reduce]);

	return (
		<ul className={`shopping-list__item-list ${className}`}>
			{shoppingList.map((i, ii) => (
				<ListItem key={ii} item={i} />
			))}
			{withDeliverySelect && (
				<li className="delivery-select-item">
					<DeliverySelect
						value={delivery}
						onChange={setDelivery}
					/>
				</li>
			)}
		</ul>
	);
};

export default ListView;
